import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { registerSyncHandlers } from './lib/sync';
import './styles/tokens.css';
import './styles/global.css';

registerSyncHandlers();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
